import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import { Outlet, Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const Menu = () => {

  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear cookies
    document.cookie = "token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict";
    document.cookie = "userid=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict";

    // Optionally, clear other localStorage data (if necessary)
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("welcomeMessageShown");

    // Redirect to login page
    navigate("/login");
  };

  const toggleSidebar = (e) => {
    e.preventDefault();
    const body = document.body;
    if (body.classList.contains('sidebar-collapse')) {
      body.classList.remove('sidebar-collapse');
    } else {
      body.classList.add('sidebar-collapse');
    }
  };

  const toggleSubmenu = (e) => {
    e.preventDefault();
    const parent = e.currentTarget.parentElement;
    const isOpen = parent.classList.contains('menu-open');

    // Close all other submenus
    document.querySelectorAll('.nav-item.has-treeview').forEach(item => {
      if (item !== parent) {
        item.classList.remove('menu-open');
      }
    });

    // Toggle current submenu
    if (isOpen) {
      parent.classList.remove('menu-open');
    } else {
      parent.classList.add('menu-open');
    }
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{
        __html: `
          /* Force sidebar colors - override AdminLTE */
          .main-sidebar {
            background-color: #343a40 !important;
            color: #fff !important;
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            height: 100vh !important;
            overflow: hidden !important;
          }
          
          .sidebar {
            background-color: #343a40 !important;
            color: #fff !important;
            height: 100vh !important;
            overflow-y: auto !important;
            overflow-x: hidden !important;
            padding-bottom: 50px !important;
          }
          
          .main-sidebar *, .sidebar * {
            color: inherit !important;
          }
          
          .nav-sidebar .nav-link {
            color: rgba(255, 255, 255, 0.8) !important;
            background-color: transparent !important;
          }
          
          .nav-sidebar .nav-link:hover,
          .nav-sidebar .nav-link:focus {
            color: #fff !important;
            background-color: rgba(255, 255, 255, 0.1) !important;
          }
          
          .nav-sidebar .nav-link.active {
            color: #fff !important;
            background-color: rgba(255, 255, 255, 0.15) !important;
          }
          
          .nav-treeview .nav-link {
            color: rgba(255, 255, 255, 0.7) !important;
            background-color: transparent !important;
          }
          
          .nav-treeview .nav-link:hover,
          .nav-treeview .nav-link:focus {
            color: #fff !important;
            background-color: rgba(255, 255, 255, 0.05) !important;
          }
          
          .nav-treeview .nav-link.active {
            color: #fff !important;
            background-color: rgba(255, 255, 255, 0.1) !important;
          }
          
          .nav-sidebar > .nav-item > .nav-link.active {
            background-color: rgba(255, 255, 255, 0.15) !important;
            color: #fff !important;
          }
          
          .nav-sidebar > .nav-item > .nav-link:hover {
            background-color: rgba(255, 255, 255, 0.1) !important;
            color: #fff !important;
          }
          
          .nav-icon {
            color: rgba(255, 255, 255, 0.8) !important;
          }
          
          .nav-link p {
            color: rgba(255, 255, 255, 0.8) !important;
          }
          
          .nav-treeview .nav-icon {
            color: rgba(255, 255, 255, 0.7) !important;
          }
          
          .nav-treeview .nav-link p {
            color: rgba(255, 255, 255, 0.7) !important;
          }
          
          .user-panel a {
            color: #fff !important;
          }
          
          /* Override any AdminLTE theme variables */
          .sidebar-dark-primary {
            background-color: #343a40 !important;
          }
          
          .sidebar-dark-primary .nav-sidebar > .nav-item > .nav-link.active,
          .sidebar-dark-primary .nav-sidebar > .nav-item > .nav-link:hover {
            background-color: rgba(255, 255, 255, 0.15) !important;
            color: #fff !important;
          }
          
          /* Ensure scrollbar styling */
          .sidebar::-webkit-scrollbar {
            width: 8px;
          }
          
          .sidebar::-webkit-scrollbar-track {
            background: #343a40;
          }
          
          .sidebar::-webkit-scrollbar-thumb {
            background: #495057;
            border-radius: 4px;
          }
          
          .sidebar::-webkit-scrollbar-thumb:hover {
            background: #6c757d;
          }
        `
      }} />
      {/* <Header/> */}
      <div className="wrapper">
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" data-widget="pushmenu" href="#" role="button" onClick={toggleSidebar}><i className="fas fa-bars" /></a>
            </li>
          </ul>

          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <button onClick={handleLogout}
                id="add-sub"
                className="btn btn-info">

                Logout
              </button>
            </li>
          </ul>
        </nav>
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
          <div className="sidebar">
            <div className="user-panel mt-3 pb-3 mb-3 d-flex">
              <div className="info">
                <a href="#" className="d-block">Admin</a>
              </div>
            </div>
            <nav className="mt-2">
              <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

                {/* Dashboard */}
                <li className="nav-item">
                  <Link to="/" className="nav-link">
                    <i className="nav-icon fas fa-tachometer-alt" />
                    <p>Dashboard</p>
                  </Link>
                </li>

                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-book-open" />
                    <p>
                      Catalogue Dashboard
                      <i className="right fas fa-angle-down" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/catalog-dashboard" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Catalogue Dashboard</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/pos-dashboard" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>POS Dashboard</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/catalog-statistics" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Catalogue Statistics</p>
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* POS Dashboard Menu with Submenu */}
                {/* <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-cash-register" />
                    <p>
                      POS Dashboard
                      <i className="right fas fa-angle-down" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <a href="/pos-dashboard" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>POS Dashboard</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href="/pos-statistics" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>POS Statistics</p>
                      </a>
                    </li>
                  </ul>
                </li> */}

                {/* Devices Management Menu with Submenu */}
                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-microchip" />
                    <p>
                      Devices Management
                      <i className="right fas fa-angle-down" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/merchantList" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Merchant List</p>
                      </Link>
                    </li>
                    
                    <li className="nav-item">
                      <Link to="/group" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Group</p>
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link to="/devicesList" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Devices List</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/serialnoMqttSetting" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Device Upload</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/device-package" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Device Package</p>
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link to="/healthPackage" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Health Package</p>
                      </Link>
                    </li> */}
                  </ul>
                </li>

                {/* Content Management Menu with Submenu */}
                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-folder-open" />
                    <p>
                      Content Management
                      <i className="right fas fa-angle-down" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">

                    {/* <li className="nav-item">
                      <Link to="/compaign" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Campaign</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/audio" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Audio</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/audioPackage" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Audio Pack</p>
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link to="/catelog" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Catalogue</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/default-catalog" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Default Catalog</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/default-html" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Default HTML</p>
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link to="/schedulelist" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Schedule</p>
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link to="/dqr-image-list" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Dqr Images</p>
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link to="/firmware" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Application</p>
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link to="/htmldoclist" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Html Doc</p>
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link to="/htmldocziplist" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Html Doc Zip</p>
                      </Link>
                    </li>

                    {/* <li className="nav-item">
                      <Link to="/mqttSetting" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Json Setting</p>
                      </Link>
                    </li> */}
                    
                    {/* <li className="nav-item">
                      <Link to="/AWSIOTCoreList" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>AWSIOT Core List</p>
                      </Link>
                    </li> */}

                  </ul>
                </li>

                {/* Send Menu with Submenu */}
                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-paper-plane" />
                    <p>
                      Send
                      <i className="right fas fa-angle-down" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    {/* <li className="nav-item">
                      <Link to="/sendcompaign" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Campaign</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/sendaudio" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Audio</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/sendaudioPackage" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Audio Pack</p>
                      </Link>
                    </li> */}
                    {/* <li className="nav-item">
                      <Link to="/senddynamicqr" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Dynamic Qr</p>
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link to="/send-catelog" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Catalogue</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/sendSchedule" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Schedule</p>
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link to="/send-Dqr-image" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send DQR Images</p>
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link to="/send-firmware" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Application</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Send-Row-Json" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Raw Json</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/sendSerialnoMqttSetting" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Serialno Mqtt Setting</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/sendhtmldoc" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Html Doc</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/sendhtmldoczip" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Send Html Doc Zip</p>
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link to="/sendAWSIOTCore" className="nav-link">
                        <i className="nav-icon fas fa-cloud" />
                        <p>Send AWSIOT Core List</p>
                      </Link>
                    </li> */}
                  </ul>
                </li>

                {/* System Setting Menu with Submenu */}
                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-cogs" />
                    <p>
                      System Setting
                      <i className="right fas fa-angle-down" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/userList" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>User List</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/action-operation" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Action Operation</p>
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link to="/apiDoc" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>API Doc</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Client-page" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Client List</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/upload-file-list" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Upload File</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/android-devices" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Android</p>
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link to="/systemParamList" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>System Param</p>
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link to="/default-template" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Auto Template</p>
                      </Link>
                    </li> */}
                  </ul>
                </li>

                {/* History Menu with Submenu */}
                <li className="nav-item has-treeview">
                  <a href="#" className="nav-link" onClick={toggleSubmenu}>
                    <i className="nav-icon fas fa-history" />
                    <p>
                      History
                      <i className="right fas fa-angle-down" />
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/history" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>History</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/device-history-last-data" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Device History Last Data</p>
                      </Link>
                    </li>
                  </ul>

                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/messageQueueList" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Message Queue</p>
                      </Link>
                    </li>
                  </ul>

                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/socketReqHistoryList" className="nav-link">
                        <i className="far fa-circle nav-icon" />
                        <p>Socket Req History</p>
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="nav-item">
                  <Link to="/send" className="nav-link">
                    <i className="nav-icon fas fa-vial" />
                    <p>Test WS</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/Login-for-client" className="nav-link">
                    <i className="nav-icon fas fa-sign-in-alt" />
                    <p>Login</p>
                  </Link>
                </li>

              </ul>
            </nav>
          </div>
        </aside>
        <aside className="control-sidebar control-sidebar-dark">
        </aside>
      </div>
      <Outlet />
    </>
  );
};

export default Menu;
